import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { LoginComponent } from "../login/login.component";
import { TransporterLoginComponent } from "src/app/truck-owner/transporter-login/transporter-login.component";
import { GoogleMap } from "@angular/google-maps";
import { Observable, startWith } from "rxjs";
import { CustomerServiceService } from "src/app/customer/customer-service.service";
import { SharedService } from "../shared.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DeviceDetectionService } from "src/app/device-detection.service";
import { Router } from "@angular/router";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-corporate-header",
  templateUrl: "./corporate-header.component.html",
  styleUrls: ["./corporate-header.component.css"],
})
export class CorporateHeaderComponent implements OnInit {
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  matDialogref: MatDialogRef<LoginComponent> | undefined;
  MatDialogref: MatDialogRef<TransporterLoginComponent>;
  scrollevent: boolean = false;
  mobileToggleEvent: boolean = false;
  coordinatesForm!: FormGroup;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  dropAutoComplete: any;
  drop_long_name: any = "";
  drop_short_name: any = "";
  completeDropAddress: any;
  completePickUpAddress: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  truckCategory: any = [];
  truckWeight: any = [];
  searchBtn: boolean = true;
  token: any;
  truckDetails: any;
  @ViewChild(GoogleMap) map: GoogleMap | any;
  loginSignup: boolean = true;
  profile: boolean = false;
  profilePic: any;
  userName: any;
  pickup_postal_code: any;
  dropoff_postal_code: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  myControl = new FormControl();
  filterWeight: Observable<any[]> | undefined;
  tripSearchData: any;
  search: any;
  userType: any;
  user: any;
  loading: boolean = false;
  locationError: boolean = false;
  locationsMatch: boolean = false;
  showCloseIconPick = false;
  showCloseIconDrop = false;
  dropPlace: any;
  pickupPlace: any;

  // isAndroidDevice: boolean = false;
  // isLaptopDevice: boolean = false;

  constructor(
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private services: CustomerServiceService,
    private router: Router,
    private shrdSrvce: SharedService,
    private snackBar: MatSnackBar,
    private deviceDetectionService: DeviceDetectionService
  ) {
    this.minDate.setDate(this.minDate.getDate() - 0);
    this.maxDate.setDate(this.maxDate.getDate() + 2);
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");

    this.GetProfileDetails();
    // this.isAndroidDevice = this.deviceDetectionService.isAndroid();
    // this.isLaptopDevice = this.deviceDetectionService.isLaptop();

    // if (this.isAndroidDevice == true) {
    //   this.snackBar.open("Please use Desktop Device", "Ok", {
    //     duration: 3000,
    //   });
    // } else {
    //   this.snackBar.open("Please use Android Device", "Ok", {
    //     duration: 3000,
    //   });
    // }

    this.coordinatesForm = this.fb.group({
      pickup: ["", Validators.required],
      drop: ["", Validators.required],
      date: [""],
      truck_category: ["", [Validators.required]],
      // truck_type: ["", [Validators.required]],
    });
    this.GetCategory();
    if (this.token == null) {
      this.loginSignup = true;
    } else {
      this.profile = true;
      this.loginSignup = false;
    }

    this.filterWeight = this.myControl.valueChanges.pipe(
      startWith(""),
      this.map((value: string) => this._filterType(value))
    );
    this.user = sessionStorage.getItem("corporate_user_type");

    this.shrdSrvce.currentsearchDetails.subscribe((result: any) => {
      if (result && result.searchData) {
        var SearchTruckDetails = result.searchData;
        this.coordinatesForm.controls["pickup"].setValue(
          `${SearchTruckDetails.completePickUpAddress.formatted_address}`
        );
        this.coordinatesForm.controls["drop"].setValue(
          `${SearchTruckDetails.completeDropAddress.formatted_address}`
        );
        this.coordinatesForm.controls["date"].setValue(
          `${SearchTruckDetails.date}`
        );
        this.coordinatesForm.controls["truck_category"].setValue(
          `${SearchTruckDetails.truck_category}`
        );
        // this.pickup_long_name = this.SearchTruckDetails.fromLocation.from_area_name;
        this.pickup_short_name = SearchTruckDetails.fromLocation.from_city_name;
        this.pickup_postal_code = SearchTruckDetails.fromLocation.from_pincode;
        this.pickupLat = SearchTruckDetails.fromLocation.from_lat;
        this.pickupLong = SearchTruckDetails.fromLocation.from_long;
        this.drop_long_name = SearchTruckDetails.toLocation.to_area_name;
        this.drop_short_name = SearchTruckDetails.toLocation.to_city_name;
        this.dropoff_postal_code = SearchTruckDetails.toLocation.to_pincode;
        this.dropLat = SearchTruckDetails.toLocation.to_lat;
        this.dropLong = SearchTruckDetails.toLocation.to_long;
        this.completePickUpAddress = SearchTruckDetails.completePickUpAddress;
        this.completeDropAddress = SearchTruckDetails.completeDropAddress;
        this.GetTruckWeight();
      } else {
        this.router.navigateByUrl("/");
      }
    });
    this.coordinatesForm.get("pickup")?.valueChanges.subscribe((value) => {
      this.showCloseIconPick = !!value;
    });
    this.coordinatesForm.get("drop")?.valueChanges.subscribe((value) => {
      this.showCloseIconDrop = !!value;
    });
  }

  private _filterType(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.truckWeight
      .map((ele: any) => ({ _id: ele._id, truck_weight: ele.truck_weight }))
      .filter((option: any) => option.truck_weight.length > 0);
  }

  public GetProfileDetails() {
    this.token = sessionStorage.getItem("corporate_token");
    this.userName = sessionStorage.getItem("corporateUserName");
    this.profilePic = sessionStorage.getItem("corporateProfilePic");
  }

  ngAfterViewInit(): void {
    var options = {
      // types: ['(cities)'],
      types: ["geocode"], // Restrict to geographical locations
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
    this.onInputPickUpchange();
    this.onDropChange();
  }

  public GetCategory() {
    this.services.GetCategory().subscribe((response: any) => {
      if (response.status === 200) {
        this.truckCategory = response.body.data
        .filter((item: any) => item.truck_category_name)
        .sort((a: any, b: any) => a.truck_category_name.localeCompare(b.truck_category_name));
      }
    });
  }

  public GetTruckWeight() {
    var category = this.coordinatesForm.value.truck_category;
    this.services.GettruckWeight(category).subscribe((response: any) => {
      if (response.status === 200) {
        this.truckWeight = response.body.data;
        this.filterWeight = this.truckWeight;
      }
    });
  }

  login(routeFrom: string) {
    this.matDialogref = this.matDialog.open(LoginComponent, {
      width: "500px",
      data: {
        routeFrom: routeFrom,
        tripSearchData: this.tripSearchData,
      },
    });
  }

  GoToProfile() {
    sessionStorage.removeItem("quoteBooked");
    this.userType = sessionStorage.getItem("corporate_user_type");
    if (this.userType === "corporate") {
      this.router.navigateByUrl("/corporate/profile");
    } else {
      this.router.navigateByUrl("/profile");
    }
  }

  trips() {
    this.userType = sessionStorage.getItem("corporate_user_type");
    if (this.userType === "corporate") {
      this.router.navigateByUrl("/corporate/trips");
    } else {
      this.router.navigateByUrl("/trips");
    }
  }

  loginTransporter() {
    const tokenDummy =
      sessionStorage.getItem("token") ||
      sessionStorage.getItem("corporate_token") ||
      sessionStorage.getItem("to_token");

    if (tokenDummy) {
      // If the token exists (not null, undefined, or an empty string)
      this.snackBar.open("You are already logged in", "Ok", {
        duration: 5000,
      });
      return; // Stop the sendOTP function from proceeding
    }
    this.MatDialogref = this.matDialog.open(TransporterLoginComponent, {
      width: "500px",
    });
  }

  Logout() {
    // localStorage.clear();
    sessionStorage.removeItem("corporate_token");
    sessionStorage.removeItem("corporateProfilePic");
    sessionStorage.removeItem("corporateUserName");
    sessionStorage.removeItem("corporate_user_type");
    window.location.reload();
    this.router.navigateByUrl("/");
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      this.scrollevent = true;
    } else {
      this.scrollevent = false;
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (event.target.innerWidth > 991) {
      this.mobileToggleEvent = false;
    }
  }

  mobileToggle() {
    this.mobileToggleEvent = !this.mobileToggleEvent;
  }

  onInputPickUpchange() {
    this.geoCodePickUp(this.coordinatesForm.value.pickup);
    this.checkLocations();
  }

  onDropChange() {
    this.geoCodeDrop(this.coordinatesForm.value.drop);
    this.checkLocations();
  }

  numberWith4Decimal(num: any) {
    num = num.toString(); //If it's not already a String
    num = num.slice(0, num.indexOf(".") + 5); //With 3 exposing the hundredths place
    return num; //If you need it back as a Number
  }
  checkLocations() {
    const pickups = this.coordinatesForm.get("pickup")?.value;
    const dropup = this.coordinatesForm.get("drop")?.value;
    if (pickups && dropup && pickups === dropup) {
      return;
    }
  }
  requestQuote() {
    const pickups = this.coordinatesForm.get("pickup")?.value;
    const dropup = this.coordinatesForm.get("drop")?.value;
    if (pickups && dropup && pickups === dropup) {
      this.snackBar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }
    sessionStorage.removeItem("loadDetails");
    this.token = sessionStorage.getItem("corporate_token");
    let pick = this.coordinatesForm.value.pickup;
    this.loading = true;
    if (!pick) {
      this.snackBar.open("Please select pickup location", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    let drop = this.coordinatesForm.value.drop;
    if (!drop) {
      this.snackBar.open("Please select dropup location", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    let date = this.coordinatesForm.value.date;
    if (!date) {
      this.snackBar.open("Please select date", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    let categ = this.coordinatesForm.value.truck_category;
    if (!categ) {
      this.snackBar.open("Please select truck category", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    // if (this.user != "corporate") {
    //   let type = this.coordinatesForm.value.truck_type;
    //   if (!type) {
    //     this.snackBar.open("Please select truck type", "Fail", {
    //       duration: 5000,
    //     });
    //     this.loading = false;
    //     return;
    //   }
    // }
    if (this.user == "customer") {
      this.tripSearchData = {
        fromLocation: {
          from_area_name: this.pickup_long_name, //pickDetails[0],
          from_city_name: this.pickup_short_name, //pickDetails[1],
          from_pincode: this.pickup_postal_code, // this.completePickUpAddress.address_components[this.completePickUpAddress.address_components.length-1]
          from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLat),
          from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLong)
        },
        toLocation: {
          to_area_name: this.drop_long_name, //dropDetails[0],
          to_city_name: this.drop_short_name, //dropDetails[1],
          to_pincode: this.dropoff_postal_code, // this.completeDropAddress.address_components[this.completeDropAddress.address_components.length-1],
          to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLat),
          to_long: (Math.round(this.dropLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLong)
        },
        date: formatDate(this.coordinatesForm.value.date, "yyyy-MM-dd", "en"),
        truck_category: this.coordinatesForm.value.truck_category,
        truck_type: this.coordinatesForm.value.truck_type,
        completePickUpAddress: this.completePickUpAddress,
        completeDropAddress: this.completeDropAddress,
        truckCategory: this.truckCategory,
        truckWeight: this.truckWeight,
      };
      this.loading = false;
    } else {
      this.tripSearchData = {
        fromLocation: {
          from_area_name: this.pickup_long_name, //pickDetails[0],
          from_city_name: this.pickup_short_name, //pickDetails[1],
          from_pincode: this.pickup_postal_code, // this.completePickUpAddress.address_components[this.completePickUpAddress.address_components.length-1]
          from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLat),
          from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLong)
        },
        toLocation: {
          to_area_name: this.drop_long_name, //dropDetails[0],
          to_city_name: this.drop_short_name, //dropDetails[1],
          to_pincode: this.dropoff_postal_code, // this.completeDropAddress.address_components[this.completeDropAddress.address_components.length-1],
          to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLat),
          to_long: (Math.round(this.dropLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLong)
        },
        date: formatDate(this.coordinatesForm.value.date, "yyyy-MM-dd", "en"),
        truck_category: this.coordinatesForm.value.truck_category,
        truck_type: this.coordinatesForm.value.truck_type,
        completePickUpAddress: this.completePickUpAddress,
        completeDropAddress: this.completeDropAddress,
        truckCategory: this.truckCategory,
        // truckWeight: this.truckWeight,
      };
      this.loading = false;
    }

    if (this.token) {
      this.searchBtn = true;
      this.tripSearch();
      this.searchBtn = false;
    } else {
      this.login("Search");
    }
  }

  tripSearch() {
    this.token = sessionStorage.getItem("corporate_token");
    this.services
      .SearchTruckDetails(this.tripSearchData, this.token)
      .subscribe((response: any) => {
        if (response.status === 201) {
          this.truckDetails = response.body.data;
          this.tripSearchData["truckweight"] = this.truckWeight.find(
            (ele: any) => {
              return ele._id === this.coordinatesForm.value.truck_type;
            }
          );
          this.tripSearchData["truckDetails"] = this.truckDetails;
          this.tripSearchData["truckCategory"] = {
            id: this.coordinatesForm.value.truck_category,
            name: this.truckCategory.find((ele: any) => {
              if (ele._id === this.coordinatesForm.value.truck_category) {
                return ele.truck_category_name;
              }
            }),
          };
          (this.tripSearchData["completePickUpAddress"] =
            this.completePickUpAddress),
            (this.tripSearchData["completeDropAddress"] =
              this.completeDropAddress),
            (this.tripSearchData["dropPlace"] = this.dropPlace);
          this.tripSearchData["pickupPlace"] = this.pickupPlace;
          sessionStorage.setItem(
            "searchData",
            JSON.stringify(this.tripSearchData)
          );
          const searchdata = {
            searchData: this.tripSearchData,
            data: this.truckDetails,
            truckweight: this.truckWeight.find((ele: any) => {
              return ele._id === this.coordinatesForm.value.truck_type;
            }),
            truckCategory: {
              id: this.coordinatesForm.value.truck_category,
              name: this.truckCategory.find((ele: any) => {
                if (ele._id === this.coordinatesForm.value.truck_category) {
                  return ele.truck_category_name;
                }
              }),
            },
          };
          this.shrdSrvce.updateSearchDetails(searchdata);
          if (this.token === null) {
            this.login("Search");
            return;
          } else {
            const userType = sessionStorage.getItem("corporate_user_type");
            if (userType === "corporate") {
              this.router.navigateByUrl("/corporate/create-work-order");
            } else {
              this.router.navigateByUrl("/truck-details");
            }
          }
        }
      });
  }
  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        console.log("place", place);
        
        const geoCoder = new google.maps.Geocoder();
        this.pickupPlace = place;
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            console.log("results<<<<>>>>", results);

            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              console.log("latlong", latlong);

              this.autoCompletePickupGeoCode(geoCoder, latlong);

              this.coordinatesForm.controls["pickup"].setValue(
                place.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }
  autoCompletePickupGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      this.completePickUpAddress = result[0];
      console.log("this.completePickUpAddress", this.completePickUpAddress);

      for (
        let i = 0;
        i < this.completePickUpAddress.address_components.length;
        i++
      ) {
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
            "locality" &&
          this.completePickUpAddress.address_components[i].types[1] ==
            "political"
        ) {
        }
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
            "political" &&
          this.completePickUpAddress.address_components[i].types[1] ==
            "sublocality" &&
          this.completePickUpAddress.address_components[i].types[2] ==
            "sublocality_level_1"
        ) {
          this.pickup_long_name =
            this.completePickUpAddress.address_components[i].long_name;
        }
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
          "postal_code"
        ) {
        }
        if (this.pickup_short_name && this.pickup_long_name) {
        }
      }
    });
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.dropPlace = dropPlace;

        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },

          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);

              this.coordinatesForm.controls["drop"].setValue(
                dropPlace.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }
  autoCompleteDropGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      this.completeDropAddress = result[0];
      for (
        let i = 0;
        i < this.completeDropAddress.address_components.length;
        i++
      ) {
        if (
          this.completeDropAddress.address_components[i].types[0] ==
            "locality" &&
          this.completeDropAddress.address_components[i].types[1] == "political"
        ) {
          this.drop_short_name =
            this.completeDropAddress.address_components[i].long_name;
        }
        if (
          this.completeDropAddress.address_components[i].types[0] ==
            "political" &&
          this.completeDropAddress.address_components[i].types[1] ==
            "sublocality" &&
          this.completeDropAddress.address_components[i].types[2] ==
            "sublocality_level_1"
        ) {
          this.drop_long_name =
            this.completeDropAddress.address_components[i].long_name;
        }
        if (
          this.completeDropAddress.address_components[i].types[0] ==
          "postal_code"
        ) {
        }
      }
    });
  }
  clearPickField() {
    this.coordinatesForm.get("pickup")?.setValue("");
    this.showCloseIconPick = false;
    this.onInputPickUpchange();
  }
  clearDropField() {
    this.coordinatesForm.get("drop")?.setValue("");
    this.showCloseIconDrop = false;
    this.onDropChange();
  }
}
